<article class="c-list-item c-list-item-placeholder" [id]="itemElementId">
  <img
    class="c-list-item__thumbnail t-brand-background-color qa-item__thumbnail"
    [src]="resourceImage"
    alt=""
  />

  <div class="c-list-item__content">
    <div class="c-list-item__content--info">
      <header class="c-list-item__meta">
        <rl-citation-placeholder></rl-citation-placeholder>
      </header>
    </div>
  </div>
</article>
